import { useState } from "react";
import {
  PricingComponentCardDiv,
  PricingComponentHeroDiv,
  PricingComponentMainDiv,
} from "../../styles/pricingcomponentsstyles/pricingcomponentstyles";
import Footer from "../reusable/footer/footer";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import HeaderComponent from "../reusable/header/header";
import ButtonComponent from "../reusable/header/assetes/buttoncomponents/butttoncomponent";
import { ReactComponent as DiamondIcon } from "./assets/diamond-solid-full.svg";
import ButtonComponentVariant from "../reusable/header/assetes/buttoncomponents/buttoncomponentvarint";
import { openVsCodeExtension } from "../../utils/vscodeLauncher";
import { IndexComponentTrustedSection } from "../../styles/indexcomponentsstyles/indexcomponentstyles";
import IndexReviewsComponent from "../indexcomponents/indexsreviewscomponent";
import IndexFaqComponent from "../indexcomponents/indexfaqcomponent";
import ShinyGradient from "../reusable/svg/shinygradient";
const PricingComponent = () => {
  const [isMonthly, setIsMonthly] = useState<boolean>(true);
  return (
    <PricingComponentMainDiv>
      <ShinyGradient/>
      <div className="header-holder">
        <HeaderComponent />
      </div>
      <div>
        <PricingComponentHeroDiv isMonthly={isMonthly}>
          <div>
            <div className="pricing-hero-container">
              <div>
                <div className="pricing-header-container">
                  <div className="pricing-text-container">
                    <div>
                      <div>
                        <HeaderSpan
                          text=" PRICING & PLANS

"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="pricing-text-wrapper">
                        <h1> Choose the Plan That’s Right for You</h1>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="pricing-buttons-container">
                      <div>
                        <div
                          className="pricing-button-wrapper pricing-Monthly-button-wrapper"
                          onClick={() => {
                            setIsMonthly(true);
                          }}
                        >
                          <div>
                            <p> Monthly</p>{" "}
                          </div>
                        </div>

                        <div
                          className="pricing-button-wrapper pricing-yearly-button-wrapper"
                          onClick={() => {
                            setIsMonthly(false);
                          }}
                        >
                          <div>
                            <p> Yearly</p>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pricing-cards-container">
                {data.map((item, index) => (
                  <PricingComponentCardDiv isMonthly={isMonthly}>
                    <div>
                      <div className="pricing-card-container">
                        {item.isMostPopular ? <>
                          <div className="pricing-card-gradient"></div>
                          <div className="pricing-card-popular-tag ">
                            <p> Popular</p>{" "}
                          </div></> : <>
                        </>}



                        <div className="pricing-card-header-container">
                          <div className="pricing-card-header-text-container">
                            <div>
                              <div className="pricing-card-header-text-wrapper">
                                <h2> {item.name}</h2>
                              </div>
                            </div>
                            <div>
                              <div className="pricing-card-header-text-wrapper">
                                <p>{item.description}</p>
                              </div>
                            </div>
                          </div>
                          <div className="pricing-card-price-cotainer">
                            <div>
                              <div className="pricing-card-price-wrapper">
                                <div className="pricing-card-text-wrapper">
                                  <div className="pricing-card-price-text-wrapper price-label">
                                    <h3>{isMonthly ? item.monthly_price : item.yearly_price} </h3>
                                    <div className="pricing-card-price-text-wrapper">
                                     <p>.99</p>
                                  </div>

                                  </div>
                                  <div className="pricing-card-price-text-wrapper price-label-2">
                                    <h3>{isMonthly ? item.monthly_price : item.yearly_price} </h3>
                                    <div className="pricing-card-price-text-wrapper">
                                     <p>.99</p>
                                  </div>

                                  </div>
                                </div>
                                <div>
                                  <div className="pricing-card-price-text-wrapper">
                                     <p>/month, per user</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="pricing-card-button-cotainer">
                                {
                                  item.isMostPopular ?
                                    <ButtonComponent title="Get started " onclick={openVsCodeExtension} />
                                    : <ButtonComponentVariant title="Get started " onclick={openVsCodeExtension} />

                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr className="pricing-card-line" />
                        <div className="pricing-card-bottom-container">
                          <div className="pricing-card-feature-text-wrapper ">
                            <p>What's Included</p>
                          </div>
                          {
                            item.includes.map((include_item,include_index)=>(
                                <div key={include_index+"item includes"} className="pricing-card-feature-container">
                            <div>
                              <div className="pricing-card-icon-container ">
                                <DiamondIcon  />{" "}
                              </div>
                            </div>
                            <div>
                              <div className="pricing-card-text-container">
                                <p>{include_item} </p>
                              </div>
                            </div>
                          </div>

                            ))
                          }
                        
                        </div>
                      </div>
                    </div>
                  </PricingComponentCardDiv>
                ))}
              </div>
            </div>
          </div>
        </PricingComponentHeroDiv>
      </div>

      <IndexComponentTrustedSection>
        <div>
          <section className="trusted-section-container">
            <div className="trusted-section-holder">
              <div>
                <div className="trusted-section-text">
                  <p>Trusted by 10000+ users worldwide</p>
                </div>
              </div>

              <div className="trusted-section-marque-container">
                <div className="trusted-section-marque-gradient-cover trusted-section-marque-gradient-cover-right" />
                <div className="trusted-section-marque-gradient-cover trusted-section-marque-gradient-cover-left" />

                <div className="trusted-section-marque-scroll-holder">
                  <section>
                    <ul className="trusted-section-marque-scroll-list">
                      {Companys.map((item, index) => (
                        <li
                          key={index + "marquee items"}
                          className="trusted-section-marque-scroll-list-item"
                        >
                          <div>
                            <div>
                              <DiamondIcon className="trusted-section-marque-scroll-list-item-icon" />
                            </div>
                          </div>
                          <div className="trusted-section-marque-scroll-list-item-text">
                            <div>
                              <p>{item} </p>
                            </div>
                          </div>
                        </li>
                      ))}
                      {Companys.map((item, index) => (
                        <li
                          key={index + "marquee items"}
                          className="trusted-section-marque-scroll-list-item"
                        >
                          <div>
                            <div>
                              <DiamondIcon className="trusted-section-marque-scroll-list-item-icon" />
                            </div>
                          </div>
                          <div className="trusted-section-marque-scroll-list-item-text">
                            <div>
                              <p>{item} </p>
                            </div>
                          </div>
                        </li>
                      ))}
                      {Companys.map((item, index) => (
                        <li
                          key={index + "marquee items"}
                          className="trusted-section-marque-scroll-list-item"
                        >
                          <div>
                            <div>
                              <DiamondIcon className="trusted-section-marque-scroll-list-item-icon" />
                            </div>
                          </div>
                          <div className="trusted-section-marque-scroll-list-item-text">
                            <div>
                              <p>{item} </p>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </section>
                </div>
              </div>
            </div>
          </section>
        </div>
      </IndexComponentTrustedSection>
      <IndexReviewsComponent />
      <IndexFaqComponent />


      <div>
        <Footer />
      </div>
    </PricingComponentMainDiv>
  );
};


const Companys = [
  "Product1",
  "Product",
  "Product",
  "Product",
  "Product",
  "Product",
  "Product2",
];
const data = [
  {
    name: "Bugzi Basic",
    description: "Ideal for individual developers.",
    monthly_price: 14,
    yearly_price: 143,
    isMostPopular: false,
    includes: [
      "Code review for private repos",
      "Access to multiple AI models",
      "Code scanning",
      "AI assistant",
      "Auto Complete",
      "Access to all Bugzi plugins and MCP server"
    ]
  },
  {
    name: "Bugzi Flash",
    description: "Perfect for lightweight users.",
    monthly_price: 16,
    yearly_price: 163,
    isMostPopular: false,


    includes: [
      "Everything in Bugzi Basic",
      "Codebase context",
      "Access to premium AI models",
      "Agentic chat",
      "Extended code review for private repos",
      "Increased rate limit",
      "Increased max context window"
    ]
  },
  {
    name: "Bugzi Pro",
    description: "Designed for teams and professionals ",
    monthly_price: 19,
    yearly_price: 191,
    isMostPopular: true,


    includes: [
      "Everything in Bugzi Flash",
      "Static code quality scanning",
      "Multi-model support",
      "Static analysis reports",
      "Security checks",
      "Coverage tracking",
      "Team dashboards"
    ]
  },
  {
    name: "Bugzi Elite",
    description: "Best for enterprises and power users.",
    monthly_price: 24,
    yearly_price: 229,
    isMostPopular: false,


    includes: [
      "Everything in Bugzi Pro",
      "Customize scan rules globally",
      "Automated PR checks",
      "Automated conflict solver",
      "Unlimited access with monthly credit",
      "Linting & rule enforcement",
      "Role-based access control",
      "Privacy dashboard",
      "On-prem deployment option"
    ]
  }
]

export default PricingComponent;

